/* Homepage giveaway countdown.

   Small and self-contained so the homepage does not have to load the whole
   giveaway page bundle. It is not a second timer: the deadline comes from
   the campaign calendar in giveaway-schedule, the same instant the giveaway
   page counts to, handed over in #gw26-home-config. There is nothing to keep in
   sync by hand.

   Days, hours and minutes only. Seconds on a persistent announcement bar are
   noise, and they repaint every second for no extra urgency. The giveaway
   page still shows seconds where there is room for them.

   Only the promotion running right now is present. No future window reaches
   the browser. */
(function () {
  if (window.__gw26home) return;
  window.__gw26home = true;

  var node = document.getElementById('gw26-home-config');
  if (!node) return;

  var config;
  try { config = JSON.parse(node.textContent); } catch (e) { return; }

  function tzOffset(utcMs, timeZone) {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    var p = {};
    fmt.formatToParts(new Date(utcMs)).forEach(function (part) { p[part.type] = part.value; });
    var asUtc = Date.UTC(
      Number(p.year), Number(p.month) - 1, Number(p.day),
      Number(p.hour), Number(p.minute), Number(p.second)
    );
    return asUtc - utcMs;
  }

  /* The dates are stored as wall clock in the campaign's time zone, so they
     have to be resolved against that zone rather than the shopper's. */
  function zonedToUtc(iso, timeZone) {
    var m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/);
    if (!m) return null;
    var guess = Date.UTC(
      Number(m[1]), Number(m[2]) - 1, Number(m[3]),
      Number(m[4]), Number(m[5]), Number(m[6])
    );
    var utc = guess - tzOffset(guess, timeZone);
    return guess - tzOffset(utc, timeZone);
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* promoEndMs is an absolute instant from giveaway-schedule, already fixed
     to midnight Eastern. The wall-clock field is only read from older markup. */
  var zone = config.timeZone || 'America/New_York';
  var promoEnd = (typeof config.promoEndMs === 'number' && isFinite(config.promoEndMs))
    ? config.promoEndMs
    : zonedToUtc(config.promoEnd, zone);
  var clocks = document.querySelectorAll('[data-gwh-clock]');

  /* Once the bonus deadline passes the boost is over. Every bonus claim and
     the clock itself come out at once, and the neutral giveaway line takes
     their place for the few seconds until giveaway-clock-guard reloads the
     page and the server renders the window that follows. */
  function standDown() {
    var bonus = document.querySelectorAll('[data-gwh-bonus]');
    var base = document.querySelectorAll('[data-gwh-base]');
    var i;
    for (i = 0; i < bonus.length; i++) bonus[i].hidden = true;
    for (i = 0; i < base.length; i++) base[i].hidden = false;
  }

  function paint() {
    if (promoEnd === null) return true;
    var remain = promoEnd - Date.now();
    if (remain <= 0) {
      standDown();
      return true;
    }
    var mins = Math.floor(remain / 60000);
    var d = Math.floor(mins / 1440);
    var h = Math.floor((mins % 1440) / 60);
    var m = mins % 60;
    for (var i = 0; i < clocks.length; i++) {
      var root = clocks[i];
      var dd = root.querySelector('[data-gwh-d]');
      var hh = root.querySelector('[data-gwh-h]');
      var mm = root.querySelector('[data-gwh-m]');
      if (dd) dd.textContent = pad(d);
      if (hh) hh.textContent = pad(h);
      if (mm) mm.textContent = pad(m);
      root.setAttribute('aria-label', d + ' days ' + h + ' hours ' + m + ' minutes remaining');
      root.removeAttribute('data-gwh-pending');
    }
    return false;
  }

  if (!paint()) {
    /* Minute resolution, so a twenty second tick keeps the display honest
       without waking the page constantly. */
    var timer = window.setInterval(function () {
      if (paint()) window.clearInterval(timer);
    }, 20000);
  }
})();
